export const UNLOCK_DEVICE_TITLE = 'Unlock the device';

export const SAVE_BUTTON_COPY = 'Submit Order';

export const PAPER_HEIGHT = 'calc(100vh - 200px)';

export const PAPER_WIDTH = 'calc(100vw - 200px)';
